/* 布局 */
//前台
import Layout from "@views/layout";

const goodsorderRouter = {
    path: "/business",
    component: Layout,
    redirect: {
        name: "BUSINESS"
    },
    children: [
            {
            path: "goodsorder",
            name: "GOODSORDER",
            meta: {
                title: "订单管理",
                sort: 1,
            },
            component: () => import("@views/business/goodsorder/index.vue"),
            redirect: {
                name: "GOODSORDER_LIST",
            },
            children: [
                {
                    path: "list",
                    name: "GOODSORDER_LIST",
                    meta: {
                        title: "订单管理",
                        sort: 2,
                        keepAlive:true
                    },
                    component: () => import("@views/business/goodsorder/list.vue"),
                },
                                {
                    path: "add",
                    name: "GOODSORDER_ADD",
                    meta: {
                        title: "新增订单管理",
                        parentPath: '/business/goodsorder/list',
                        operate: true,
                    },
                    component: () => import("@views/business/goodsorder/form.vue"),
                },
                                                {
                    path: "edit",
                    name: "GOODSORDER_EDIT",
                    meta: {
                        title: "编辑订单管理",
                        parentPath: '/business/goodsorder/list',
                        operate: true,
                    },
                    component: () => import("@views/business/goodsorder/form.vue"),
                },
                                        ],
    },


        ],
};

export default goodsorderRouter;
